import React, { useState } from "react";
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsCardImage } from "react-icons/bs";
import { CircularProgress } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../_helpers";
import { IoCloseOutline } from "react-icons/io5";

export const ImagePopup = (props) => {
    const buttonStyles = {
        position: "absolute",
        top: "10px",
        right: "10px",
    };
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [imageload, setImageLoad] = useState(false);
    return (
        <>
            <BsCardImage
                className="cursor-pointer text-primary mx-1 text-center"
                onClick={() => handleShow()}
            />
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <div className="modal-header-custom">
                    <OverlayTrigger placement="bottom" overlay={ <Tooltip id="tooltip"> Close </Tooltip> } >
                        <IoCloseOutline   className="modal-icon" onClick={handleClose} />
                    </OverlayTrigger>
                </div>
                <Modal.Body>
                    {imageload ? (
                        ""
                    ) : (
                        <div className="loader-container">
                            <CircularProgress />
                            <h6>Please Wait...</h6>
                        </div>
                    )}
                    <div style={{ textAlign: "center" }}>
                        <img
                            src={`${props.Image}`}
                            alt={props.Shape}
                            className="img-fluid"
                            height="500px"
                            width="500px"
                            style={{ objectFit: "cover" }}
                            onLoad={() => setImageLoad(true)}
                            onError={e => toAbsoluteUrl(
                                e.currentTarget.src = `/media/shape/${props.Shape ? props.Shape.toLowerCase() : ""}-no.png`
                            )}
                        />
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                        style={buttonStyles}
                    >
                        Close
                    </Button>
                </Modal.Footer> */}
            </Modal>
        </>
    );
};
